export const isProductionApp = () =>
  typeof window !== 'undefined' &&
  (window.origin === 'https://app.mellow.finance' ||
    window.origin === 'https://mellow.finance' ||
    window.origin === 'https://curation.mellow.finance');
